// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthWrapper_wrapper__8Gv9e","in-focus":"AuthWrapper_in-focus__N2sB3","signup-subheading":"AuthWrapper_signup-subheading__SxoWZ"};